import styles from '../header/Header.module.scss';
import closeIcon from "./assets/newCloseIcon.png";

interface IProps {
  isMobile?: boolean
}

const HeaderClose = ({ isMobile }: IProps) =>
  !isMobile ? (
    <img className={styles.closeIcon} src={closeIcon} alt="" width={12} height={12} />
  ) : (
    <img src={closeIcon} alt="" width={12} height={12} />
  )
export default HeaderClose
